import { render, staticRenderFns } from "./DoughnutTotalNominations.vue?vue&type=template&id=5d44fc64"
import script from "./DoughnutTotalNominations.vue?vue&type=script&lang=js"
export * from "./DoughnutTotalNominations.vue?vue&type=script&lang=js"
import style0 from "./DoughnutTotalNominations.vue?vue&type=style&index=0&id=5d44fc64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports